var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationStatusLoaderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "loader",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.333,
    height: 51.863,
    viewBox: "0 0 54.333 51.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23775",
    "data-name": "Group 23775",
    transform: "translate(-1126.551 -177.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22781",
    "data-name": "Path 22781",
    d: "M99.44,164.849a2.47,2.47,0,0,0-2.47,2.47v4.939a2.47,2.47,0,1,0,4.939,0v-4.939a2.47,2.47,0,0,0-2.47-2.47",
    transform: "translate(1054.278 54.938)",
    fill: "#c4d9fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22782",
    "data-name": "Path 22782",
    d: "M36.11,138.834l-6.985,6.986a2.47,2.47,0,0,0,3.493,3.493l6.985-6.986a2.47,2.47,0,0,0-3.493-3.493",
    transform: "translate(1105.383 74.866)",
    fill: "#c4d9fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22779",
    "data-name": "Path 22779",
    d: "M12.348,96.97H2.47a2.47,2.47,0,0,0,0,4.939h9.879a2.47,2.47,0,1,0,0-4.939",
    transform: "translate(1126.551 105.529)",
    fill: "#73a1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22784",
    "data-name": "Path 22784",
    d: "M32.619,29.125a2.47,2.47,0,1,0-3.493,3.493L36.111,39.6A2.47,2.47,0,0,0,39.6,36.111Z",
    transform: "translate(1105.382 156.634)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22783",
    "data-name": "Path 22783",
    d: "M99.44,0a2.47,2.47,0,0,0-2.47,2.47v9.879a2.47,2.47,0,1,0,4.939,0V2.47A2.47,2.47,0,0,0,99.44,0",
    transform: "translate(1054.278 177.802)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22780",
    "data-name": "Path 22780",
    d: "M145.819,29.125l-6.986,6.986a2.47,2.47,0,1,0,3.493,3.493l6.986-6.986a2.47,2.47,0,1,0-3.493-3.493",
    transform: "translate(1023.616 156.634)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22778",
    "data-name": "Path 22778",
    d: "M167.5,96.97h-9.879a2.47,2.47,0,0,0,0,4.939H167.5a2.47,2.47,0,0,0,0-4.939",
    transform: "translate(1010.915 105.529)",
    fill: "#1c2448"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationStatusLoaderIcon);
export default __webpack_public_path__ + "static/media/application-status-loader-icon.dd312df1185e5bccfc0b0ccc06cd40d8.svg";
export { ForwardRef as ReactComponent };